import React, { useState } from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined, CloseOutlined } from '@ant-design/icons';
import { Layout } from 'antd';
import { Drawer, Button, Modal } from 'antd';
import { Col, Row } from 'antd';
import MenuItems from './MenuItems';
import "./game-style.css";
import { ArrowBackRounded, ArrowForwardRounded, CheckCircleRounded } from '@mui/icons-material';
import GameLogoJpg from './images/GameLogo.jpg';
import img21Jpg from './images/img21.jpg';
import img22Jpg from './images/img22.jpg';
import img23Jpg from './images/img23.jpg';
import img24Jpg from './images/img24.jpg';
import img25Jpg from './images/img25.jpg';
import gameBgJpg from './images/gameBg.jpg';
import bg1Jpg from './images/bg1.jpg';
import bg2Jpg from './images/bg2.jpg';
import SentryWrap from 'components/Sentry';

const { Sider, Content } = Layout;
function GameEbook() {
    const [collapsed, setCollapsed] = useState(false);

    const [visible, setVisible] = useState(false);
    const showDrawer = () => {
        setVisible(true);
    };
    const onClose = () => {
        setVisible(false);
    };

    const [modalVisible, setModalVisible] = useState(false);
    const [currentSection, setCurrentSection] = useState(1);

    const showModal = () => {
        setModalVisible(true);
        setCurrentSection(1);
    };

    const handleNext = () => {
        setCurrentSection(currentSection + 1);
    };

    const handlePrevious = () => {
        setCurrentSection(currentSection - 1);
    };

    const handleCancel = () => {
        setModalVisible(false);
    };

    const [showOptions, setShowOptions] = useState(false);

    const toggleOptions = () => {
        setShowOptions(!showOptions);
    };

    return (
        <SentryWrap>
        <Layout>
            {/* Website Menu Design */}
            <div className="WebMenuLayout cmnTopSpc">
                <Sider trigger={null} collapsible collapsed={collapsed}>
                    <div className="menuLayout">
                        <div className='gameLogo'>
                            <a><img src={GameLogoJpg} alt="" /></a>
                        </div>
                        <div className="addMenuItems">
                            <MenuItems />
                        </div>
                    </div>
                </Sider>
            </div>
            {/* End of Website Menu Design */}

            <Layout>
                {/* Mobile Menu Design */}
                <nav className="menuBar">
                    <div className="mobileMenuLayout">
                        <Row>
                            <Col xs={{ span: 23 }} className="mobileMenuUpr">
                                <div className="mobileMenuSet">
                                    <div className='gameLogo'>
                                        <a><img src={GameLogoJpg} alt="" /></a>
                                    </div>
                                    <Button className="barsMenu" type="primary" onClick={showDrawer}>
                                        <span className="barsBtn"></span>
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                        <Drawer
                            //title="Basic Drawer"
                            placement="left"
                            closable={false}
                            onClose={onClose}
                            visible={visible}>
                            <div className="menuLayout">
                                <div className='gameLogo'>
                                    <a><img src={GameLogoJpg} alt="" /></a>
                                </div>
                                <div className="addMenuItems">
                                    <MenuItems />
                                </div>
                            </div>
                        </Drawer>
                    </div>
                </nav>
                {/* End of Mobile Menu Design */}

                <Content style={{ minHeight: '100vh' }}>

                    <div className='gmHmRight cmnTopSpc'>
                        <div className='welComeUser'>
                            <div className='welComeUserInr'>
                                <Button type="text"
                                    icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                                    onClick={() => setCollapsed(!collapsed)}
                                />
                                <h1>Welcome, Claudia Alves!</h1>
                            </div>
                            <div className='welUsrRght'><a><ArrowBackRounded /><span>Back to Nosotros Online</span></a></div>
                        </div>

                        <Row>
                            <Col xs={{ span: 24 }} lg={{ span: 16 }}>
                                <div className='oneGmPopup'>
                                    <Button className='gmPopupBtn' onClick={toggleOptions}>
                                        <img src={GameLogoJpg} alt="" />
                                    </Button>
                                    {showOptions && (
                                        <div className="gmDropdownOptn">
                                            <button onClick={showModal}>See OWE created</button>
                                            <button onClick={showModal}>See teacher created</button>
                                            <button onClick={showModal}>Created my 1Game</button>
                                        </div>
                                    )}
                                </div>

                                <div>
                                    <Modal
                                        //title={`Section ${currentSection}`}
                                        visible={modalVisible}
                                        onCancel={handleCancel}
                                        closeIcon={<CloseOutlined />}
                                        className='gameOneMdl'
                                        footer={[
                                            <Button key="previous" disabled={currentSection === 1} onClick={handlePrevious}>
                                                Previous
                                            </Button>,
                                            <Button key="next" disabled={currentSection === 4} onClick={handleNext}>
                                                Next
                                            </Button>,
                                        ]}
                                    >
                                        <div>
                                            {currentSection === 1 && <div className='gmCollectionUpr'>
                                                <div className='gmCollection'>
                                                    <div className='myUnitsGm'>
                                                        <div className='myUnitsBnr'><img src={img21Jpg} alt="" /></div>
                                                        <div className='myUnitsTxt'>
                                                            <div className='myUnitsInfo'>
                                                                <label>La Familla Primero</label>
                                                                <p>Anecdotas 5</p>
                                                                <span>Pg. 12</span>
                                                            </div>
                                                            <div className='myUnitsBtns'>
                                                                <a className='BtnsPrev'>Preview</a>
                                                                <a className='BtnsStart'><ArrowForwardRounded />start</a>
                                                            </div>
                                                            <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                                                        </div>
                                                    </div>

                                                    <div className='myUnitsGm'>
                                                        <div className='myUnitsBnr'><img src={img22Jpg} alt="" /></div>
                                                        <div className='myUnitsTxt'>
                                                            <div className='myUnitsInfo'>
                                                                <label>La Familla Primero</label>
                                                                <p>Anecdotas 2</p>
                                                                <span>Pg. 12</span>
                                                            </div>
                                                            <div className='myUnitsBtns'>
                                                                <a className='BtnsPrev'>Preview</a>
                                                                <a className='BtnsStart'><ArrowForwardRounded />start</a>
                                                            </div>
                                                            <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                                                        </div>
                                                    </div>

                                                    <div className='myUnitsGm'>
                                                        <div className='myUnitsBnr'><img src={img23Jpg} alt="" /></div>
                                                        <div className='myUnitsTxt'>
                                                            <div className='myUnitsInfo'>
                                                                <label>La Familla Primero</label>
                                                                <p>Anecdotas 1</p>
                                                                <span>Pg. 12</span>
                                                            </div>
                                                            <div className='myUnitsBtns'>
                                                                <a className='BtnsPrev'>Preview</a>
                                                                <a className='BtnsStart'><ArrowForwardRounded />start</a>
                                                            </div>
                                                            <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                                                        </div>
                                                    </div>

                                                    <div className='myUnitsGm'>
                                                        <div className='myUnitsBnr'><img src={img24Jpg} alt="" /></div>
                                                        <div className='myUnitsTxt'>
                                                            <div className='myUnitsInfo'>
                                                                <label>La Familla Primero</label>
                                                                <p>Anecdotas 3</p>
                                                                <span>Pg. 12</span>
                                                            </div>
                                                            <div className='myUnitsBtns'>
                                                                <a className='BtnsPrev'>Preview</a>
                                                                <a className='BtnsStart'><ArrowForwardRounded />start</a>
                                                            </div>
                                                            <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                                                        </div>
                                                    </div>

                                                    <div className='myUnitsGm'>
                                                        <div className='myUnitsBnr'><img src={img25Jpg} alt="" /></div>
                                                        <div className='myUnitsTxt'>
                                                            <div className='myUnitsInfo'>
                                                                <label>La Familla Primero</label>
                                                                <p>Anecdotas 4</p>
                                                                <span>Pg. 12</span>
                                                            </div>
                                                            <div className='myUnitsBtns'>
                                                                <a className='BtnsPrev'>Preview</a>
                                                                <a className='BtnsStart'><ArrowForwardRounded />start</a>
                                                            </div>
                                                            <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>}
                                            {currentSection === 2 &&
                                                <div className='gmCollection2'>
                                                    <div className='myUnitsGm'>
                                                        <div className='myUnitsBnr'><img src={img21Jpg} alt="" /></div>
                                                        <div className='myUnitsTxt'>
                                                            <div className='myUnitsInfo'>
                                                                <label>La Familla Primero</label>
                                                                <p>Anecdotas 5</p>
                                                                <span>Pg. 12</span>
                                                            </div>
                                                            <div className='myUnitsBtns'>
                                                                <a className='BtnsPrev'>Preview</a>
                                                                <a className='BtnsStart'><ArrowForwardRounded />start</a>
                                                            </div>
                                                            <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                                                        </div>
                                                    </div>
                                                    <div className='gmPlayBtns'>
                                                        <div className='playFun'><Button>Play for fun</Button></div>
                                                        <div className='playGrade'><Button>Play for a grade</Button></div>
                                                    </div>
                                                </div>
                                            }
                                            {currentSection === 3 &&
                                                <div className='gmCollection3'>
                                                    <div className='gameLoading'>
                                                        <img src={gameBgJpg} alt="" />

                                                        {/* <div className='gameLoadingLft'>
                                                            <img src={bg1Jpg} alt="" />
                                                        </div>
                                                        <div className='gameLoadingRght'>
                                                            <img src={bg2Jpg} alt="" />
                                                        </div> */}
                                                    </div>
                                                </div>
                                            }

                                        </div>
                                    </Modal>
                                </div>

                            </Col>
                        </Row>

                    </div>

                </Content>
            </Layout>
        </Layout>
        </SentryWrap>
    );
}

export default GameEbook;